// extracted by mini-css-extract-plugin
export default {"root":"k6cep8","withoutFooter":"Zg1VXg","selectable":"q0F5lM"};